import React from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import ContentContainer from './ContentContainer';
import Cards from '../../../../components/molecules/cards';
import { Delete, Pencil as PencilIcon } from '../../../../components/atoms/icons';
import Modal from '../../../../components/organisms/modals';
import { successUpdateMsg, CONTACT_ROLES } from '../../../../components/atoms/const';
import dummyClientById from './clientById.json';
import geAllRolesRes from '../../../../components/api/user/getAllRoles.json';

interface Props {
    onNavigate: () => void;
    data: typeof dummyClientById.contactPerson;
    // eslint-disable-next-line no-unused-vars
    handleDelete: (id: number) => void;
    resultDelete: any;
    afterDelete: () => void;
    loadingDelete: boolean;
    clientId: string;
    // roleList: typeof geAllRolesRes.data;
}

function RenderContactPerson(props: Props) {
  const {
    onNavigate, data, afterDelete, loadingDelete, resultDelete, handleDelete,
    clientId,
  } = props;
  const renderModalBodyDelete = ():string => {
    if (!resultDelete) return 'Are you sure to remove this contact?';
    return successUpdateMsg.SUCCESS_DELETE_CLIENT_CONTACT_MSG;
  };
  return (
    <ContentContainer
      buttonLabel="+ Add Contact Person"
      onNavigate={onNavigate}
      buttonWidth={200}
      title="Contact Person"
    >
      <div className="row">
        {data.map((contact) => (
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-2" key={contact.id}>
            <Cards.Contact
              id={contact.id.toString()}
              name={`${contact.firstname} ${contact.lastname}` ?? '-'}
              email={contact.email ?? '-'}
              phone={contact.phoneNumber ?? '-'}
              position={contact.position ?? '-'}
              role={CONTACT_ROLES.find((role) => role.value === contact.role)?.label ?? '-'}
              deleteIcon={(
                <Modal.Default
                  cancelLabel="No"
                  submitLabel="Yes"
                  title="Delete Contact"
                  body={renderModalBodyDelete()}
                  size="sm"
                  isLoading={loadingDelete}
                  result={resultDelete}
                  onAfterResult={afterDelete}
                  onSubmit={() => handleDelete(contact.id)}
                >
                  <Delete width={18} color="black" />
                </Modal.Default>
              )}
              editIcon={(
                <Link to={`/clients/contact/${clientId}/${contact.id}`}>
                  <PencilIcon width={20} color="black" />
                </Link>
              )}
            />
          </div>
        ))}
      </div>
    </ContentContainer>
  );
}

export default RenderContactPerson;
